import * as actionTypes from 'constants/ActionTypes';

const preferences = (state = {
    items: [],
    selected: {},
    isLoaded: false,
}, action) => {

    switch (action.type) {
        case actionTypes.GET_PREFERENCE.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_PREFERENCE.SUCCESS:
            return {
                ...state,
            };
        case actionTypes.GET_PREFERENCE.FAILURE:
            return {
                ...state,
            };

        case actionTypes.GET_PREFERENCES.REQUEST:
            return {
                ...state,
                isLoaded: false,
            };
        case actionTypes.GET_PREFERENCES.SUCCESS:
            return {
                ...state,
                isLoaded: true,
                items: action.data,
            };
        case actionTypes.GET_PREFERENCES.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        case actionTypes.UPDATE_PREFERENCE_META.REQUEST:
            return {
                ...state,
            };
        case actionTypes.UPDATE_PREFERENCE_META.SUCCESS:
            return {
                ...state,
            };
        case actionTypes.UPDATE_PREFERENCE_META.FAILURE:
            return {
                ...state,
            };

        case actionTypes.DELETE_PREFERENCE.REQUEST:
            return {
                ...state,
            };
        case actionTypes.DELETE_PREFERENCE.SUCCESS:
            return {
                selected: {},
                items: state.items.filter((item) => {
                    return item._id !== action.data._id;
                }),
            };
        case actionTypes.DELETE_PREFERENCE.FAILURE:
            return {
                ...state,
            };


        case actionTypes.CHANGE_PREFERENCE: {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    shared: typeof action.data.shared !== 'undefined' ? action.data.shared : state.selected.shared,
                    filter: {
                        ...state.selected.filter,
                        levelList: action.data.levelList,
                        selectedType: action.data.selectedType,
                    }
                }
            };
        }

        case actionTypes.CLEAR_SELECT_PREFERENCE: {
            return {
                ...state,
                selected: {},
            };
        }

        case actionTypes.SELECT_PREFERENCE: {
            return {
                ...state,
                selected: state.items.find((item) => {
                    return item._id === action.data._id;
                }),
            };
        }

        case actionTypes.CREATE_FILTER_ANNOTATIONS_PREFERENCE.REQUEST:
            return {
                ...state,
            };
        case actionTypes.CREATE_FILTER_ANNOTATIONS_PREFERENCE.SUCCESS:
            const { items } = state;

            items.push(action.data);

            return {
                selected: action.data,
                items,
            };
        case actionTypes.CREATE_FILTER_ANNOTATIONS_PREFERENCE.FAILURE:
            return {
                ...state,
            };

        case actionTypes.UPDATE_PREFERENCE.REQUEST:
            return {
                ...state,
            };
        case actionTypes.UPDATE_PREFERENCE.SUCCESS:
            return {
                ...state,
                items: state.items.map((item) => {
                    if (item._id === action.data._id) {
                        return action.data;
                    }

                    return item;
                }),
            };
        case actionTypes.UPDATE_PREFERENCE.FAILURE:
            return {
                ...state,
            };

        case actionTypes.UPDATE_MAIL_RECOGNIZE_SPAM_LIST.REQUEST:
            return {
                ...state,
                isLoaded: false,
            };
        case actionTypes.UPDATE_MAIL_RECOGNIZE_SPAM_LIST.SUCCESS:
            return {
                ...state,
                isLoaded: true,
            };
        case actionTypes.UPDATE_MAIL_RECOGNIZE_SPAM_LIST.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };


        case actionTypes.GET_MAIL_RECOGNIZE_SPAM_LIST.REQUEST:
            return {
                ...state,
                isLoaded: false,
            };
        case actionTypes.GET_MAIL_RECOGNIZE_SPAM_LIST.SUCCESS:
            return {
                ...state,
                items: [ action.data ],
                isLoaded: true,
            };
        case actionTypes.GET_MAIL_RECOGNIZE_SPAM_LIST.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        case actionTypes.CREATE_MAIL_RECOGNIZE_SPAM_LIST.REQUEST:
            return {
                ...state,
            };
        case actionTypes.CREATE_MAIL_RECOGNIZE_SPAM_LIST.SUCCESS:
            return {
                ...state,
            };
        case actionTypes.CREATE_MAIL_RECOGNIZE_SPAM_LIST.FAILURE:
            return {
                ...state,
            };


        default:
            return state;
    }
};

export default preferences;



// WEBPACK FOOTER //
// ./app/reducers/preferences/index.js